import React, {Component} from 'react';
import {Row, Col, Form, Input, Button} from 'antd';
import {api, app} from "../../app";

const FormItem = Form.Item;

class PwdSet extends Component {
    constructor(props) {
        super(props);
        this.state = {
            send: false
        };
    }

    /**
     * 提交信息
     * @param e
     */
    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                console.log(values);
                if (this.state.submit_loading) return false;
                if (!this.state.send) {
                    app.alert('请先获取验证码', 'warn');
                    return false;
                }
                this.setState({submit_loading: true}, () => {
                    const _this = this;
                    values.password = values.password1;
                    delete values.password1;
                    app.post(api.SetPwd, values).then(({flag, data, msg}) => {
                        if (flag === 1) {
                            app.alert("设置成功，请重新登录", "success");
                            _this.props.form.resetFields();
                            _this.props.onClose(true);
                        } else {
                            app.alert(msg, "error");
                        }
                        _this.setState({submit_loading: false});
                    });
                })
            }
        });
    }

    /**
     * 获取验证码
     * @param e
     */
    handleSendCode = (e) => {
        e.preventDefault();
        const {validateFields} = this.props.form, _this = this;
        validateFields(['name', 'idno'], {force: true}, (err, values) => {
            if (!err) {
                this.setState({send_loading: true}, () => {
                    app.post(api.SendSMS, values).then(({flag, data, msg}) => {
                        if (flag === 1) {
                            app.alert(msg, "success");
                            _this.setState({send: true});
                        } else {
                            app.alert(msg, "error");
                        }
                        _this.setState({send_loading: false});
                    });
                });
            }
        });

    }

    /**
     * 确认密码
     * @param rule
     * @param value
     * @param callback
     */
    handleConfirmPassword = (rule, value, callback) => {
        const {getFieldValue} = this.props.form
        if (value && value !== getFieldValue('password1')) {
            callback('两次密码输入不一致！')
        }

        // Note: 必须总是返回一个 callback，否则 validateFieldsAndScroll 无法响应
        callback()
    }

    render() {
        const formItemLayout = {
                wrapperCol: {span: 16, offset: 4},
            },
            send = this.state.send,
            send_loading = this.state.send_loading,
            submit_loading = this.state.submit_loading,
            {getFieldDecorator} = this.props.form;
        return (
            <div className="pwd-set">
                <Form onSubmit={this.handleSubmit}>
                    <FormItem
                        {...formItemLayout}
                    >{getFieldDecorator('name', {
                        rules: [{
                            required: true, message: '请填写您的姓名！',
                        }],
                    })(
                        <Input placeholder="姓名" maxLength={36} size="large"/>
                    )}
                    </FormItem>
                    <FormItem
                        {...formItemLayout}
                    >{getFieldDecorator('idno', {
                        rules: [
                            {required: true, message: '请填写您的身份证号码！'}
                        ],
                    })(
                        <Input placeholder="身份证号码（15-18位）" size="large"/>
                    )}
                    </FormItem>
                    <FormItem
                        {...formItemLayout}
                    >{getFieldDecorator('password1', {
                        rules: [{
                            required: true, message: '请填写登录密码！',
                        }, {
                            min: 8, message: '密码最少8位！',
                        }],
                    })(
                        <Input type="password" placeholder="请输入密码 8位数字/字母/字符" maxLength={16} size="large"/>
                    )}
                    </FormItem>
                    <FormItem
                        {...formItemLayout}
                    >{getFieldDecorator('confirm_password', {
                        rules: [
                            {required: true, message: '请填写确认密码！'},
                            {validator: this.handleConfirmPassword}
                        ],
                    })(
                        <Input type="password" placeholder="再次输入密码 8位数字/字母/字符" maxLength={16} size="large"/>
                    )}
                    </FormItem>
                    <FormItem
                        {...formItemLayout}
                    >
                        <Row>
                            <Col span={14}>
                                {getFieldDecorator('SMScode', {
                                    rules: [{
                                        required: true, message: '请填写手机验证码！',
                                    }],
                                })(
                                    <Input placeholder="手机验证码" size="large"/>
                                )}
                            </Col>
                            <Col span={9} offset={1}>
                                <Button type="primary" style={{width: '100%'}} size="large" loading={send_loading}
                                        onClick={this.handleSendCode}>{send ? '重新发送' : '获取验证码'}</Button>
                            </Col>
                        </Row>
                    </FormItem>
                    <div style={{textAlign: 'center'}}>
                        <Button htmlType="submit" loading={submit_loading} type="primary" size="large">确定</Button>
                    </div>
                </Form>
            </div>
        );
    }
}

export default Form.create()(PwdSet);



// WEBPACK FOOTER //
// ./src/routes/login/PwdSet.jsx